import { memo } from 'react';
import styles from './PassedDates.module.scss';
import Box from '@/components/UI/box/Box';
const Passeddays = ({
  numberOfRows
}) => {
  return <>
      {Array.from({
      length: numberOfRows
    }, (_, index) => <Box key={index + 33} className={`${styles['day-tag']} ${styles['empty-day-tag']}`}></Box>)}
    </>;
};
export default memo(Passeddays);